var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      class: [_vm.$style["mds-checkbox"], _vm.classObject, _vm.sizeClass],
      attrs: { for: _vm.inputId, "data-mds-version": _vm.version },
    },
    [
      _c(
        "input",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.modelValue,
                expression: "modelValue",
              },
            ],
            ref: "input",
            class: _vm.$style["mds-checkbox__input"],
            attrs: {
              type: "checkbox",
              disabled: _vm.disabled,
              id: _vm.inputId,
              "aria-checked": _vm.modelValue,
            },
            domProps: {
              value: _vm.value,
              checked: Array.isArray(_vm.modelValue)
                ? _vm._i(_vm.modelValue, _vm.value) > -1
                : _vm.modelValue,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.modelValue,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = _vm.value,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.modelValue = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.modelValue = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.modelValue = $$c
                }
              },
            },
          },
          "input",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          class: _vm.$style["mds-checkbox__visible-wrap"],
          attrs: { "data-mds-ref-checked": _vm.refChecked },
        },
        [
          _c(
            "span",
            { class: _vm.$style["mds-checkbox__visual"] },
            [
              _c("mds-icon", {
                class: _vm.$style["mds-checkbox__checked-icon"],
                attrs: { name: "check", size: _vm.iconSize },
              }),
              _vm._v(" "),
              _c("mds-icon", {
                class: _vm.$style["mds-checkbox__indeterminate-icon"],
                attrs: { name: "minus", size: _vm.iconSize },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { class: _vm.$style["mds-checkbox__text"] },
            [
              _vm._t("default", function () {
                return [_vm._v(_vm._s(_vm.label))]
              }),
              _vm._v(" "),
              _vm.microcopy || _vm.hasMicrocopySlotContent
                ? _c(
                    "span",
                    { class: _vm.$style["mds-checkbox__microcopy"] },
                    [
                      _vm._t("mds-microcopy", function () {
                        return [
                          _vm.microcopy
                            ? _c("span", {
                                domProps: { innerHTML: _vm._s(_vm.microcopy) },
                              })
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }